import axios from "axios";

export const putCatchReportEdit = async (catchReportID: number) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/CatchReport/edit?CatchReportID=${catchReportID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
